<template>
    <div>
        <b-modal id="m-input-barang-masuk-external" title="Input Barang Masuk External" size="xl" no-close-on-backdrop
            no-close-on-esc hide-footer @show="init()">
            <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
            <div v-else>
                <b-row class="mt-3">
                    <b-col md="6">
                        <div class="font-weight-bold">Jenis Barang</div>
                        <multiselect v-model="kindId" :allow-empty="false" label="name" track-by="id"
                            :internal-search="true" @input="fetchMerkBarang" placeholder="-- Pilih Salah Satu --"
                            :options="kinds" />
                        <!-- <b-form-select v-model="kindId" text-field="name" value-field="id" te :options="kinds"
                    @change="fetchMerkBarang" /> -->
                        <div class="font-weight-bold mt-3">Merk Barang</div>
                        <multiselect t :disabled="fetch || !kindId" v-model="brandId" :allow-empty="false" label="name"
                            track-by="id" :internal-search="true" @input="fetchTipeBarang"
                            placeholder="-- Pilih Salah Satu --" :options="brands" />
                        <!-- <b-form-select :disabled="fetch || !kindId" v-model="brandId" text-field="name" value-field="id"
                    :options="brands" @change="fetchTipeBarang" /> -->
                        <!-- {{ item.brand }} -->
                        <div class="font-weight-bold mt-3">Tipe Barang</div>
                        <multiselect t :disabled="fetch || !brandId" v-model="typeId" :allow-empty="false" label="name"
                            track-by="id" :internal-search="true" @input="fetchTahunBarang"
                            placeholder="-- Pilih Salah Satu --" :options="types" />
                        <!-- <b-form-select :disabled="fetch || !brandId" v-model="typeId" text-field="name" value-field="id"
                    :options="types" @change="fetchTahunBarang($event)" /> -->
                        <div v-if="hasYear">
                            <div class="font-weight-bold mt-3">Tahun / Generasi Barang</div>

                            <multiselect t :disabled="fetch || !typeId" v-model="yearId" :allow-empty="false"
                                label="year" track-by="id" :internal-search="true" placeholder="-- Pilih Salah Satu --"
                                :options="years" />
                            <!-- <b-form-select :disabled="fetch || !typeId" v-model="yearId" text-field="year" value-field="id"
                        :options="years" /> -->
                        </div>
                    </b-col>
                    <b-col md="6">
                        <div class="font-weight-bold mt-3">IMEI / SN</div>
                        <b-input v-model="input.imeiSn" />
                        <div class="font-weight-bold mt-3">Password</div>
                        <b-input v-model="input.password" />
                        <div class="font-weight-bold mt-3">Description</div>
                        <b-form-textarea v-model="input.description" />
                    </b-col>
                </b-row>
                <hr>
                <h5>Input Data Barang</h5>
                <b-row class="mt-3">
                    <b-col md="3">
                        <b-form-group label="Grade Barang">
                            <b-form-select v-model="input.grade" :options="optGrade" />
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group label="Kelengkapan Barang">
                            <b-form-select v-model="input.isBatangan" :options="optBatangan" />
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group label="Spek Barang">
                            <b-form-select v-model="input.spec" :options="optSpec" text-field="name" value-field="id" />
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group label="Warna Barang">
                            <b-form-select v-model="input.color" :options="optColor" text-field="name"
                                value-field="id" />
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group label="Modal">
                            <b-input-group prepend="Rp.">
                                <b-form-input v-model="input.capital" maxlength="50"
                                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                    @input="sanitizeCapital" />
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <!-- <b-col md="3">
                        <b-form-group label="Harga di Gadai">
                            <b-input-group prepend="Rp.">
                                <b-form-input v-model="input.priceAtPawn" maxlength="50"
                                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                    @input="sanitizePriceAtPawn" />
                            </b-input-group>
                        </b-form-group>
                    </b-col> -->
                </b-row>
                <b-row v-if="input.grade == 'X'">
                    <b-col md="12">
                        <b-form-group :label="'Penyesuaian Harga Grade ' + input.grade"
                            description="Gunakan tanda negatif didepan untuk pengurangan harga (Bila positif, maka dianggap penambahan harga)">
                            <b-input-group prepend="Rp.">
                                <b-input v-model="input.adjGrade" @input="sanitizeAdjGrade" />
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>
                <!-- <b-row>
                    <b-col md="6">
                        <b-form-group label="Accessories yang Tidak Ada">
                            <multiselect :disabled="fetch || !kindId" v-model="input.missingAcc" :multiple="true"
                                label="name" track-by="id" :internal-search="true" deselect-label="" select-label=""
                                :options="optAccessories" :close-on-select="false" />
                        </b-form-group>
                    </b-col>
                    <b-col md="6">
                        <b-form-group label="Accessories yang Tidak Ori">
                            <multiselect :disabled="fetch || !kindId" v-model="input.nonOriAcc" :multiple="true"
                                label="name" track-by="id" :internal-search="true" deselect-label="" select-label=""
                                :options="optAccessories" :close-on-select="false" />
                        </b-form-group>
                    </b-col>
                </b-row> -->

                <b-col md="12" class="mb-4">
                    <b-table bordered hover show-empty no-local-sorting :items="adjustments" :fields="fieldsAdjust"
                        responsive class="mt-4 mb-1">
                        <template v-slot:empty>
                            Tidak ada adjustment.
                        </template>

                        <template v-slot:cell(category)="row">
                            <!-- <b-form-input v-model="row.item.name" maxlength="50" /> -->
                            <!-- diubah sementara supaya adjustment harga bisa diinput manual dulu -->
                            <!-- <b-form-select v-model="row.item.adjustmentSelect" :options="optAdjustments" @change="onChangeAdjustmentSelect($event, row.index)" /> -->
                            <!-- <b-form-select v-model="row.item.category" :options="optCategory" @change="onChangeRowCategory(row.index)"
                                :disabled="(activeItem.status == '3' && !activeItem.fixing_adjustment)"/> -->
                            <b-form-select v-model="row.item.category" :options="optCategory"
                                @change="onChangeRowCategory(row.index)" />
                        </template>

                        <template v-slot:cell(name)="row">
                            <!-- <b-form-input v-model="row.item.name" maxlength="50" /> -->
                            <!-- diubah sementara supaya adjustment harga bisa diinput manual dulu -->
                            <!-- <b-form-select v-model="row.item.adjustmentSelect" :options="optAdjustments" @change="onChangeAdjustmentSelect($event, row.index)" /> -->
                            <!-- <b-form-select v-model="row.item.adjustmentSelect" :options="row.item.optAdjustments" @change="changeAdjustment" :disabled="(activeItem.status == '3' && !activeItem.fixing_adjustment)"/>
                                <small class="text-muted" v-if="row.item.adjustmentSelect === null || row.item.adjustmentSelect.id == null">{{row.item.name_placeholder}}</small> -->
                            <b-form-select v-model="row.item.adjustmentSelect" :options="row.item.optAdjustments"
                                :disabled="!row.item.category || row.item.optAdjustments.length <= 0" />
                        </template>

                        <template v-slot:cell(adjustment)="row">
                            <b-input-group prepend="Rp.">
                                <!-- diubah sementara supaya adjustment harga bisa diinput manual dulu -->
                                <!-- <b-form-input v-model="row.item.adjustment" @input="sanitize(row.item)" disabled></b-form-input> -->
                                <!-- <b-form-input v-model="row.item.adjustment" @input="sanitize(row.item)" :disabled="(row.item.adjustmentPercentage != '' && row.item.adjustmentPercentage != null) || activeItem.status == '3'" ></b-form-input> -->
                                <b-form-input v-model="row.item.adjustment" @input="sanitize(row.item)"
                                    :disabled="(row.item.adjustmentPercentage != '' && row.item.adjustmentPercentage != null) || !row.item.adjustmentSelect"></b-form-input>
                            </b-input-group>
                        </template>

                        <template v-slot:cell(adjustmentPercent)="row">
                            <b-input-group append="%">
                                <!-- diubah sementara supaya adjustment harga bisa diinput manual dulu -->
                                <!-- <b-form-input v-model="row.item.adjustmentPercentage" disabled></b-form-input> -->
                                <!-- <b-form-input v-model="row.item.adjustmentPercentage" @input="changeAdjustment" :disabled="(row.item.adjustment != '' && row.item.adjustment != null) || activeItem.status == '3'"></b-form-input> -->
                                <b-form-input v-model="row.item.adjustmentPercentage"
                                    :disabled="(row.item.adjustment != '' && row.item.adjustment != null) || !row.item.adjustmentSelect"></b-form-input>
                            </b-input-group>
                        </template>

                        <template v-slot:cell(action)="row">
                            <div class="d-flex">
                                <b-button size="sm" variant="success" v-b-tooltip.hover.top title="Tambah"
                                    @click="addRow">
                                    <i class="fa fa-fw fa-plus" />
                                </b-button>
                                <b-button variant="danger" size="sm" class="ml-2" v-b-tooltip.hover.top title="Hapus"
                                    @click="deleteRow(row.index)">
                                    <i class="fa fa-fw fa-times" />
                                </b-button>
                            </div>
                        </template>
                    </b-table>
                    <span class="text-muted small mt-1">Biarkan tabel kosong apabila tidak ada adjustment harga</span>
                </b-col>

                <b-row>
                    <b-col md="12" class="text-right">
                        <b-button variant="success" :disabled="isSubmitting" @click="promptSubmit">
                            {{ isSubmitting ? "Menyimpan..." : "Submit Barang" }}
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>

        <b-modal id="m-barcode" title="Cetak Barcode" centered no-close-on-backdrop no-close-on-esc hide-footer
            hide-header-close>
            Silahkan cetak barcode dibawah ini. Mohon pastikan barcode tercetak dengan baik sebelum melanjutkan.
            <br /><br />
            <iframe :src="getBarcodeLink()" height="300px" width="100%" />
            <div class="mt-4">
                <b-row>
                    <b-col md="6">
                        <b-button variant="dark" :disabled="barcodeToggleCooldown" @click="toggleBarcodeType">
                            Print {{ barcodeType == 'barcode' ? 'Kerusakan' : 'Barcode' }}
                        </b-button>
                    </b-col>
                    <b-col md="6" class="text-right">
                        <b-button variant="primary" @click="finishApproval">
                            Tutup
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'modal-input-barang-masuk-external',
    data() {
        return {
            initStatus: 0,
            isSubmitting: false,
            input: {
                year: null,
                isHandphone: null,
                isBatangan: 0, // Default Lengkap
                imeiSn: null,
                grade: "A", // Default A
                password: null,
                color: null,
                capital: null,
                spec: null, // Default Resmi
                priceAtPawn: null,
                adjGrade: null,
                missingAcc: [],
                nonOriAcc: [],
                description: null,
            },

            optGrade: ["S", "A", "B", "C", "X"],
            optSpec: [],
            optWarehouse: [],
            optBatangan: [
                { value: 0, text: "Lengkap" },
                { value: 1, text: "Batangan" }
            ],
            optColor: [],
            optAccessories: [],
            optYear: [],
            kinds: [],
            brands: [],
            types: [],
            years: [],
            kindId: null,
            brandId: null,
            typeId: null,
            yearId: null,
            fetch: false,

            adjustments: [],
            optAdjustments: [],
            optCategory: [],

            fieldsAdjust: [
                { key: "category", label: "Kategori", sortable: false, thClass: 'adjust-column-min' },
                { key: "name", label: "Keterangan", sortable: false, thClass: 'adjust-column-min' },
                { key: "adjustment", label: "Potongan / Tambahan Harga (Nominal)", sortable: false },
                { key: "adjustmentPercent", label: "Potongan / Tambahan Harga (Persen)", sortable: false },
                { key: "action", label: "Aksi" },
            ],

            barcodeLinkDamage: null,
            barcodeLink: null,
            barcodeType: 'barcode',
            barcodeToggleCooldown: false,


        }
    },
    methods: {
        async init() {
            this.optAccessories = [];

            this.initStatus = 0

            await Promise.all([this.fetchJenisBarang(), this.fetchColor()])


            this.initStatus = 1
        },

        async fetchAdjustment() {

            this.addRow()

            await this.$axios.get("category/selection?item_kind_id=" + this.kindId.id).then(res => {
                this.optCategory = res.data.data.map(item => {
                    return {
                        value: item.id,
                        text: item.name
                    }
                })


            })
        },

        async fetchJenisBarang() {

            this.brandId = null
            this.typeId = null
            this.yearId = null
            this.input.missingAcc = []
            this.input.nonOriAcc = []

            this.fetch = true
            await this.$axios.get('master/kinds').then((res) => {
                this.kinds = res.data.data
            }).finally(() => {
                this.fetch = false
            })
        },

        async fetchMerkBarang() {

            this.brandId = null
            this.typeId = null
            this.yearId = null
            this.input.missingAcc = []
            this.input.nonOriAcc = []

            this.fetch = true
            await this.$axios.get(`master/brands/${this.kindId.id}`).then((res) => {
                this.brands = res.data.data
            }).finally(() => {
                this.fetch = false
            })

            await this.fetchAccessories()
            await this.fetchAdjustment()
        },

        async fetchTipeBarang() {
            this.fetch = true

            this.typeId = null
            this.yearId = null
            this.input.missingAcc = []
            this.input.nonOriAcc = []

            await this.$axios.get(`master/types/${this.brandId.id}`).then((res) => {
                this.types = res.data.data
            }).finally(() => {
                this.fetch = false
            })


        },

        async fetchTahunBarang() {

            this.yearId = null

            this.fetch = true
            await this.$axios.get(`master/years/${this.typeId.id}`).then((res) => {
                this.years = res.data.data
            })

            await this.$axios.get(`master/type-price/${this.typeId.id}`).then((res) => {
                this.optSpec = res.data.data
            })

            this.fetch = false
        },


        async fetchSpec() {
            this.fetch = true
            await this.$axios.get('master/spec/selection').then((res) => {
                this.optSpec = res.data.data
            }).finally(() => {
                this.fetch = false
            })
        },

        async fetchAccessories() {
            this.fetch = true
            await this.$axios.get(`master/accessory-option?filterKind=${this.kindId.id}`).then((res) => {
                this.optAccessories = res.data.data.items
            }).finally(() => {
                this.fetch = false
            })
        },

        async fetchColor() {
            this.fetch = true
            await this.$axios.get('master/color/selection').then((res) => {
                this.optColor = res.data.data
            }).finally(() => {
                this.fetch = false
            })
        },

        promptSubmit() {
            this.$bvModal.show("m-confirm-submit")


            this.postInsertExternal()
        },

        postInsertExternal() {

            if (this.input.capital == null || this.input.capital == "" || this.input.capital == 0) {
                this.$helper.toastError(this, "Modal tidak boleh kosong")
                return
            }

            const payload = {
                "type_id": this.typeId ? this.typeId.id : null,
                "year": this.yearId ? this.yearId.year : null,
                "is_handphone": this.kindId ? this.kindId.id == 1 : null,
                "is_batangan_pgi": this.input.isBatangan,
                "imei_sn": this.input.imeiSn,
                "grade": this.input.grade,
                "password": this.input.password,
                "capital": this.$helper.toNumber(this.input.capital),
                "price_at_pawn": this.$helper.toNumber(this.input.priceAtPawn),
                "item_spec_id": this.input.spec,
                "colorId": this.input.color,
                "adjGrade": this.input.adjGrade ? this.$helper.toNumber(this.input.adjGrade) : null,
                "missing_accessories": this.input.missingAcc,
                "not_ori_accessories": this.input.nonOriAcc,
                "description": this.input.description,
                "adjInvoice": this.adjustments.map(item => {
                    return {
                        "name": item.adjustmentSelect ? item.adjustmentSelect.name : null,
                        "adjustment": this.$helper.toNumber(item.adjustment),
                        "adjustmentPercentage": this.$helper.toNumber(item.adjustmentPercentage) ? this.$helper.toNumber(item.adjustmentPercentage) : "",
                        "adjustment_id": item.adjustmentSelect ? item.adjustmentSelect.id : null,
                    }
                })
            }

            this.isSubmitting = true
            this.$axios.post('delivery/insert-external', payload).then((res) => {
                this.$bvModal.hide("m-input-barang-masuk-external")
                this.$emit("refresh")
                this.clearInput()

                this.barcodeLink = res.data.data.link
                this.barcodeLinkDamage = res.data.data.linkDamage
                this.$bvModal.show('m-barcode')

            }).catch(error => {
                // error message validate laravel
                if (error.response.status == 422) {
                    this.$helper.toastError(this, error.response.data.message)
                }
                else {
                    this.$helper.parseError(this, error)
                }
            })
                .finally(() => this.isSubmitting = false)
        },

        clearInput() {
            this.input = {
                year: null,
                isHandphone: null,
                isBatangan: null,
                imeiSn: null,
                grade: null,
                password: null,
                color: null,
                capital: null,
                priceAtPawn: null,
                adjGrade: null,
                missingAcc: [],
                nonOriAcc: [],
            }

            this.kindId = null
            this.brandId = null
            this.typeId = null
            this.yearId = null
            this.adjustments = []

        },

        getBarcodeLink() {
            if (this.barcodeType == 'barcode') {
                return `${this.$BASE_PRINT_FILE_PATH}${this.barcodeLink}`
            }
            else {
                return `${this.$BASE_PRINT_FILE_PATH}${this.barcodeLinkDamage}`
            }
        },

        toggleBarcodeType() {
            this.barcodeToggleCooldown = true
            if (this.barcodeType == 'barcode') this.barcodeType = 'damage'
            else this.barcodeType = 'barcode'
            setTimeout(function () {
                this.barcodeToggleCooldown = false
            }.bind(this), 2000);
        },

        finishApproval() {
            this.$bvModal.hide('m-barcode')
            this.$emit("approved")
        },

        sanitizeCapital() {
            let cleaned = String(this.input.capital).replace(/\./g, "")
            let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            this.input.capital = res
        },

        sanitizePriceAtPawn() {
            let cleaned = String(this.input.priceAtPawn).replace(/\./g, "")
            let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            this.input.priceAtPawn = res
        },

        sanitizeAdjGrade() {
            let cleaned = String(this.input.adjGrade).replace(/\./g, "")
            let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            this.input.adjGrade = res
        },

        onChangeRowCategory(index) {
            this.adjustments[index].name = ""
            this.adjustments[index].adjustmentSelect = null
            this.adjustments[index].optAdjustments = []
            if (!this.$helper.isBlank(this.adjustments[index].category)) {
                let param = "?item_kind_id=" + this.kindId.id
                param += "&category_id=" + this.adjustments[index].category
                this.isSubmitting = true
                this.$axios.get("adjustment/selection-category" + param).then(res => {
                    this.adjustments[index].optAdjustments = res.data.data.map(item => {
                        return {
                            value: {
                                id: item.id,
                                name: item.name,
                                adjustment: item.adjustment,
                                adjustment_percentage: item.adjustment_percentage,
                            },
                            text: item.name
                        }
                    })
                    this.isSubmitting = false
                })
            }
        },

        sanitize(item) {
            let cleaned = String(item.adjustment).replace(/\./g, "")
            let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            item.adjustment = res
        },

        addRow() {
            this.adjustments.push({ name: "", category: "", adjustmentSelect: "", adjustment: "", adjustmentPercentage: "", optAdjustments: [] })
        },

        deleteRow(index) {
            this.adjustments.splice(index, 1)
            if (this.adjustments.length <= 0) {
                this.addRow()
            }
        },

    },
    mounted() {
        // this.init()
    },
    computed: {
        hasYear() {
            if (!this.typeId) return null;
            return this.typeId.has_year;
        }
    }
}
</script>
